import { render, staticRenderFns } from "./dialog-detailexpiredfile.vue?vue&type=template&id=36525bde&"
import script from "./dialog-detailexpiredfile.vue?vue&type=script&lang=js&"
export * from "./dialog-detailexpiredfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports